import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid, Checkbox } from '@mui/material';

const QuestionSummaryComponent = ({ questions }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} alignItems="center" justifyContent="center">
      <Grid item xs={12} sm={2}>
        {t('Questionnaire.Question.OrderNo')} : <span> {questions.orderNo} </span>
      </Grid>
      <Grid item xs={12} sm={2}>
        {t('Questionnaire.Question.QuestionCode')} : <span> {questions.questionCode} </span>
      </Grid>
      <Grid item xs={12} sm={5}>
        {t('Questionnaire.Question.QuestionName')} : <span> {questions.questionName} </span>
      </Grid>
      <Grid item xs={12} sm={3}>
        {t('Questionnaire.Question.Mandatory')} :{' '}
        <span>
          {' '}
          <Checkbox checked={questions.mandatory || false} onChange={event => event.preventDefault()} color='primary' />
        </span>
      </Grid>
    </Grid>
  );
};

QuestionSummaryComponent.propTypes = {
  questions: PropTypes.object.isRequired
};

export default QuestionSummaryComponent;
